module.exports = __webpack_public_path__ + "assets/img/cd8aa64198a3f5b86e0e4c5e9413efbf.svg";